export default {
  S: "#00639a",
  T: "#00639a",
};
